/**
 * Admin Auth 类型定义
 * 重新导出自动生成的类型，并扩展兼容现有代码
 */

// Token 存储 key
export const TOKEN_KEY = 'admin_token';

// 重新导出生成的类型（供外部使用）
export type {
  AdminInfo,
  AdminLoginRequest,
  AdminLoginResponse,
  TOTPSetupResponse,
  TOTPEnableRequest,
  TOTPDisableRequest,
  ApiResponseAdminLoginResponse_,
  ApiResponseAdminInfo_,
  ApiResponseTOTPSetupResponse_,
  ApiResponseNoneType_,
} from '../admin/typings.d';

// 扩展 API 命名空间，兼容现有代码
declare global {
  namespace API {
    /** 当前登录的管理员（兼容 CurrentUser） */
    interface CurrentUser {
      /** 用户 ID */
      userid?: string;
      /** 用户名 */
      name?: string;
      /** 昵称 */
      nickname?: string;
      /** 头像 */
      avatar?: string;
      /** 是否启用 TOTP */
      totpEnabled?: boolean;
      /** 最后登录时间 */
      lastLoginAt?: string;
      /** 权限标识 */
      access?: string;
    }
  }
}
